import { Text } from '@react-pdf/renderer'
import { sanitizeForPdf } from 'features/reporting/pdfGeneration/utils/formatters'

import { PdfFieldRow } from './PdfFieldRow'
import { PdfStyles } from './pdfStyles'

export const PdfFieldRows = ({
  rows,
  layout = 'columns',
}: {
  rows: ReadonlyArray<{ label: string; value: string }>
  /** Stacked rows can flow across pages; column rows stay together. */
  layout?: 'columns' | 'stacked'
}) => (
  <>
    {rows.map((row, index) =>
      layout === 'stacked' ? (
        <Text
          key={index}
          style={[PdfStyles.preformattedText, PdfStyles.stackedRow]}>
          <Text style={PdfStyles.stackedLabel}>
            {sanitizeForPdf(row.label)}
          </Text>
          {'\n'}
          {sanitizeForPdf(row.value)}
        </Text>
      ) : (
        <PdfFieldRow key={index} label={row.label}>
          <Text style={PdfStyles.preformattedText}>
            {sanitizeForPdf(row.value)}
          </Text>
        </PdfFieldRow>
      )
    )}
  </>
)
